// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon[data-v-c75148a7] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.app-settings[data-v-c75148a7] .dialog {
  min-height: 256px;
}
.app-settings__navigation[data-v-c75148a7] {
  min-width: 200px;
  margin-right: 20px;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  height: 100%;
}
.app-settings__content[data-v-c75148a7] {
  max-width: 100vw;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 24px;
  width: 100%;
  min-height: 256px;
}
.navigation-list[data-v-c75148a7] {
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  padding: 12px;
}
.navigation-list--collapsed[data-v-c75148a7] {
  display: flex;
  flex-direction: row;
  gap: 6px;
}
.navigation-list__link[data-v-c75148a7] {
  display: flex;
  align-content: center;
  font-size: 16px;
  height: 44px;
  margin: 4px 0;
  line-height: 44px;
  border-radius: var(--border-radius-pill);
  font-weight: 700;
  padding: 0 20px;
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  background-color: transparent;
  border: none;
}
.navigation-list__link[data-v-c75148a7]:hover,
.navigation-list__link[data-v-c75148a7]:focus {
  background-color: var(--color-background-hover);
}
.navigation-list__link--active[data-v-c75148a7] {
  background-color: var(--color-primary-element-light) !important;
}
.navigation-list__link--icon[data-v-c75148a7] {
  padding-inline-start: 8px;
  gap: 4px;
}
.navigation-list__link-icon[data-v-c75148a7] {
  display: flex;
  justify-content: center;
  align-content: center;
  width: 36px;
  max-width: 36px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/index-51c1f2a9.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;AACd;AACA;;EAEE,+CAA+C;AACjD;AACA;EACE,+DAA+D;AACjE;AACA;EACE,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB","sourcesContent":["@charset \"UTF-8\";\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon[data-v-c75148a7] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.app-settings[data-v-c75148a7] .dialog {\n  min-height: 256px;\n}\n.app-settings__navigation[data-v-c75148a7] {\n  min-width: 200px;\n  margin-right: 20px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: relative;\n  height: 100%;\n}\n.app-settings__content[data-v-c75148a7] {\n  max-width: 100vw;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 24px;\n  width: 100%;\n  min-height: 256px;\n}\n.navigation-list[data-v-c75148a7] {\n  height: 100%;\n  box-sizing: border-box;\n  overflow-y: auto;\n  padding: 12px;\n}\n.navigation-list--collapsed[data-v-c75148a7] {\n  display: flex;\n  flex-direction: row;\n  gap: 6px;\n}\n.navigation-list__link[data-v-c75148a7] {\n  display: flex;\n  align-content: center;\n  font-size: 16px;\n  height: 44px;\n  margin: 4px 0;\n  line-height: 44px;\n  border-radius: var(--border-radius-pill);\n  font-weight: 700;\n  padding: 0 20px;\n  cursor: pointer;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  background-color: transparent;\n  border: none;\n}\n.navigation-list__link[data-v-c75148a7]:hover,\n.navigation-list__link[data-v-c75148a7]:focus {\n  background-color: var(--color-background-hover);\n}\n.navigation-list__link--active[data-v-c75148a7] {\n  background-color: var(--color-primary-element-light) !important;\n}\n.navigation-list__link--icon[data-v-c75148a7] {\n  padding-inline-start: 8px;\n  gap: 4px;\n}\n.navigation-list__link-icon[data-v-c75148a7] {\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  width: 36px;\n  max-width: 36px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
